export default __webpack_public_path__ + "static/bravo-2-dda8ed4e11af6bbd2ee543e5b879c2c3.jpg";